import { createComponentSDKModel } from '@wix/editor-elements-integrations/corvid';
import {
  composeSDKFactories,
  createAccessibilityPropSDKFactory,
  enableDocumentScrollSDKFactory,
} from '@wix/editor-elements-corvid-utils';
import type { CorvidSDKPropsFactory } from '@wix/editor-elements-types/corvid';
import type { IResponsivePopupContainerProps } from '../ResponsivePopupContainer.types';

export type IResponsivePopupOwnSDKFactory = CorvidSDKPropsFactory<
  IResponsivePopupContainerProps,
  { setIsScrollUnderPopupEnabled: (value: boolean) => void }
>;
export const accessibilityPropsSDKFactory = createAccessibilityPropSDKFactory({
  enableLang: true,
});

export const sdk = composeSDKFactories([
  accessibilityPropsSDKFactory,
  enableDocumentScrollSDKFactory,
]);

export default createComponentSDKModel(sdk);
